// extracted by mini-css-extract-plugin
export var container = "_ee-0";
export var content = "_ee-3";
export var customerTitle = "_ee-4";
export var empty = "_ee-5";
export var gray = "_ee-6";
export var header = "_ee-7";
export var info = "_ee-8";
export var loading = "_ee-2";
export var loadingCard = "_ee-9";
export var oneLine = "_ee-a";
export var personName = "_ee-e";
export var pillContainer = "_ee-b";
export var selected = "_ee-1";
export var text = "_ee-c";
export var twoLines = "_ee-d";
export var unread = "_ee-f";
export var unreadIndicator = "_ee-g";